import * as Yup from "yup";
import { IFirmaRelationerType } from "../../../components/pages/firma/id/Stamoplysninger/FirmaRelationer";
import { dateToyyyyMMdd } from "../../../util/date";
import { getPatchOperations } from "../../../util/form";
import {
  existingRelationTest,
  firmaejerskabDelete,
} from "./firmaejerskabEjetAfFormConfig";

export const firmaejerskabEjerAfForm = (
  firmaId: string,
  firmaRelationer: IFirmaRelationerType[],
  firmaejerskabId?: string,
): FormConfig<FirmaejerskabDTO> => {
  return {
    title: "Ejer af",
    lockedValues: [
      { id: "firmaId", value: firmaId },
      {
        id: "firmaejerskabId",
        value: firmaejerskabId,
      },
    ],
    validationSchema: Yup.object({
      ejetFirmaId: Yup.string()
        .test(
          "overlappingRelationCheck",
          "Dette firma har allerede samme relation indenfor samme periode",
          function (selected) {
            return existingRelationTest(
              this.parent,
              selected,
              firmaRelationer,
              firmaejerskabId,
            );
          },
        )
        .required("Firma skal være valgt"),
      periodeFraDato: Yup.date().nullable().required("Startdato skal være sat"),
      periodeTilDatoInklusiv: Yup.date()
        .nullable()
        .when(
          "periodeFraDato",
          (periodeFraDato, yup) =>
            periodeFraDato &&
            yup.min(periodeFraDato, "Slutdato kan ikke være inden startdato"),
        ),
    }),
    form: [
      {
        component: "firma",
        id: "ejetFirmaId",
        label: "Vælg firma",
        isRequired: true,
      },
      {
        component: "datepicker",
        id: "periodeFraDato",
        label: "Startdato",
        initialValue: "",
        isRequired: true,
      },
      {
        component: "datepicker",
        id: "periodeTilDatoInklusiv",
        label: "Slutdato",
        initialValue: "",
      },
    ],
    get: `firma/${firmaId}/ejerskaber/${firmaejerskabId}`,
    post(values: FirmaejerskabDTO) {
      const { ejetFirmaId, periodeFraDato, periodeTilDatoInklusiv } = values;
      return {
        query: `firma/${firmaId}/ejerskaber`,
        body: {
          ejetFirmaId,
          periodeFraDato: dateToyyyyMMdd(periodeFraDato),
          periodeTilDatoInklusiv: periodeTilDatoInklusiv
            ? dateToyyyyMMdd(periodeTilDatoInklusiv)
            : "9999-12-31",
        },
      };
    },
    patch: (values: FirmaejerskabDTO) => {
      const ops = getPatchOperations(values);

      return {
        query: `firma/${firmaId}/ejerskaber/${firmaejerskabId}`,
        body: JSON.stringify(ops),
      };
    },
    delete: () => firmaejerskabDelete(firmaId, firmaejerskabId ?? ""),
  };
};
